export default __webpack_public_path__ + "static/media/banner-image-1.2b56674d.png";